import React from "react";
import { PricingPageArrow } from "../../../assets/icons/arrowDownIcon";
import CustomButton from "../../CustomButton";


const themeHoverText = {
  gray: "group-hover:text-gray-2500",
  blue: "group-hover:text-blue-1300",
  purple: "group-hover:text-purple-1500",
};

const themeHoverTextTablet = {
  gray: "text-gray-2500 lg:text-gray-600",
  blue: "text-blue-1300 lg:text-gray-600",
  purple: "text-purple-1500 lg:text-gray-600",
};

const themeText = {
  gray: "text-gray-600",
  blue: "text-blue-1300",
  purple: "text-purple-1500",
};

const themeFillHover = {
  gray: "group-hover:fill-gray-2700 fill-gray-600 duration-300 ease-in-out",
  blue: "group-hover:fill-blue-1300 fill-blue-1300 lg:fill-gray-600 duration-300 ease-in-out",
  purple:
    "group-hover:fill-purple-1500 fill-purple-1500 lg:fill-gray-600 duration-300 ease-in-out",
};

const themeFillCTA = {
  gray: "#434343",
  blue: "white",
  purple: "white",
};

const themeBackground = {
  gray: "text-gray-2500 bg-gray-2800 border border-gray-2200",
  blue: "bg-blue-1300 text-white border border-blue-1300",
  purple: "bg-purple-1500 text-white border border-purple-1500",
};

const themeAddOnHoverButton = {
  gray: "hover:bg-gray-3004 hover:text-gray-2500",
  blue: "hover:bg-blue-1700 hover:text-white",
  purple: "hover:bg-purple-2500 hover:text-white",
};

const themeCardOnHoverButton = {
  gray: "hover:border-gray-2500 ",
  blue: "hover:border-blue-1300",
  purple: "hover:border-purple-1500",
};

const themeCardOnHoverTabletButton = {
  gray: "border-gray-2500 ",
  blue: "border-blue-1300",
  purple: "border-purple-1500",
};

const themeAddOn = {
  gray: "bg-gray-1600 text-gray-2500",
  blue: "bg-blue-1600 text-blue-1500",
  purple: "bg-purple-100 text-purple-1500",
};

const PricingCard = ({
  heading,
  description,
  items,
  label,
  subLabel,
  onClick,
  buttonText,
  themeColor,
}) => {
  return (
    <section
      onClick={onClick}
      role="button"
      tabIndex={0}
      className={`rounded-2.5xl  flex flex-col bg-white sm:px-7 lg:px-6 px-3.5 lg:py-12 py-9 sm:py-11 group hover:cursor-pointer h-full border ease-in-out duration-500 lg:border-transparent ${themeCardOnHoverTabletButton[themeColor]} ${themeCardOnHoverButton[themeColor]}`}
    >
      <div
        className={`lg:text-gray-2500 -tracking-[1.8px] duration-300 font-manrope ease-in-out ${
          themeText[themeColor]
        } font-semibold text-3.25xl leading-10 mb-2.5 ${
          themeHoverText[themeColor]
        }`}
      >
        {heading}
      </div>
      <p className="text-base text-gray-600 -tracking-[0.4px] font-inter mb-5">
        {description}
      </p>
      <div className="flex justify-center">
      <CustomButton
          onClick={onClick}
          text={buttonText}
          icon={<PricingPageArrow fill={themeFillCTA[themeColor]} />}
          direction={`right`}
          buttonClass={`${themeBackground[themeColor]} ${themeAddOnHoverButton[themeColor]} font-manrope -tracking-[0.45px] text-base sm:text-lg py-2 sm:py-2.5 focus:outline-none`}
          isFullWidth
        />
      </div>
      <div className="flex items-center w-full text-xs font-semibold text-center text-gray-600 uppercase lg:gap-x-0 sm:gap-x-4 lg:py-6 py-5 tracking-widest_1">
        <hr
          className="h-[1px] border-0 lg:w-1/3 sm:w-2/3 xs:w-1/3 w-1/4"
          color="#8C8C8C"
        />
        <div className="w-2/3 uppercase tracking-[1.2px] font-semibold font-manrope sm:w-1/2 lg:w-3/4">
          {label}
        </div>
        <hr
          className="h-[1px] border-0 w-1/4 xs:w-1/3 sm:w-2/3 lg:w-1/3"
          color="#8C8C8C"
        />
      </div>
      {subLabel && (
        <div
          className={`font-inter lg:mb-4 ${
            subLabel && "mb-5"
          } text-base  font-medium -tracking-[0.8px] ${
            themeHoverText[themeColor]
          } ${themeHoverTextTablet[themeColor]} duration-300 ease-in-out`}
        >
          {subLabel}
        </div>
      )}
      <ul className="flex flex-col text-base text-gray-600 group-hover:text-gray-2700 font-inter">
        {items?.map((plan, index) => {
          return (
            <li
              key={`free_${index}`}
              className={`flex gap-x-2.5 items-center  gap-y-2 ${
                index !== items.length - 1 && "mb-5"
              } `}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M14.2503 2.96875H13.1581C13.0049 2.96875 12.8596 3.03906 12.7659 3.15937L6.32369 11.3203L3.23463 7.40625C3.1879 7.34692 3.12833 7.29895 3.06041 7.26593C2.99249 7.23292 2.91796 7.21572 2.84244 7.21562H1.75025C1.64557 7.21562 1.58775 7.33594 1.65182 7.41719L5.9315 12.8391C6.1315 13.0922 6.51588 13.0922 6.71744 12.8391L14.3487 3.16875C14.4128 3.08906 14.3549 2.96875 14.2503 2.96875Z"
                  className={themeFillHover[themeColor]}
                />
              </svg>
              <span className="-tracking-[0.4px] ">
                {plan?.card_feature_item?.text}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default PricingCard;
